export enum UserProfileType {
    HSBC = "HSBC",
    DEVELOPER = "DEVELOPER",
    MAIN_CONTRACTOR = "MAIN_CONTRACTOR",
    APPROVER = "APPROVER",
}
